import React from 'react';
import { Buffer } from 'buffer';
import crypto from 'crypto';
function DecryptData(txt) {
  if (txt) {
    var keyBuffer = 'S0XWDi8ktiUHpZ6wUWeVcwEQSRUg13gErVtQiokVhcQMQ8gqUBdrYasdfrKGrQ4a';
    var ivBuffer = 'ZCUZcPDJr0NGPVfj';
    var keyBuffer = (keyBuffer instanceof Buffer) ? keyBuffer : new Buffer(keyBuffer);
    var ivBuffer = (ivBuffer instanceof Buffer) ? ivBuffer : new Buffer(ivBuffer);
    keyBuffer = keyBuffer.slice(0, 32)
    var decipher = crypto.createDecipheriv('aes-256-cbc', keyBuffer, ivBuffer);
    var dec = decipher.update(txt, 'base64', 'utf8')
    dec += decipher.final('utf8');
    return JSON.parse(dec);
  }
}

export default DecryptData